import React from "react";

function Contact(props) {
    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;
    return (
        <div className="h-full">
            <iframe
                title="googleMaps"
                width="100%"
                height="100%"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=525+Everhart+Rd+%232,+Corpus+Christi,+TX+78411`}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
            ></iframe>
        </div>
    );
}

export default Contact;
